import React, {memo} from 'react';
import {qualitiesArray} from '@app/titles/models/qualities';
import {Lien} from '@app/titles/models/lien';
import {PlusOneIcon} from '@ui/icons/material/PlusOne';

interface ReleaseDateProps {
  date: string;
}

export const ReleaseDate = memo(({date}: ReleaseDateProps) => {
  const getYear = (dateString: string) => {
    const date = new Date(dateString);
    return date.getFullYear();
  };

  const releaseYear = getYear(date);
  return (
    <div className="text-gray-300 me-2 rounded bg-[#F97316] px-4 py-2 text-xs font-medium">
      {releaseYear}
    </div>
  );
});
